import React from "react";
//Limitless imports
import { useExpertMessageContext } from "../expert-message/ExpertMessageContext";
import { createSuggestions, useGraphAPIHook } from "@limitless/portal";
import { REQUEST_SECURE_DATA } from "../../apis/expert-message-secure-data/ExpertMessageSecureDataQueries";
export const useSecureData = () => {
  const messageContext = useExpertMessageContext();
  const [selectedConfig, setSelectedConfig] = React.useState(null);
  const [configOptions, setConfigOptions] = React.useState([]);
  const {
    mutateData
  } = useGraphAPIHook();
  const configSuggestions = createSuggestions(configOptions, {
    labelDataKey: "name",
    valueDataKey: "type"
  });
  React.useEffect(() => {
    var _messageContext$messa;
    if ((_messageContext$messa = messageContext.message.messageConfig) !== null && _messageContext$messa !== void 0 && _messageContext$messa.secureDataOptions) {
      setConfigOptions(messageContext.message.messageConfig.secureDataOptions);
    }
  }, [messageContext]);
  const createSecureDataRequest = callback => {
    const {
      label,
      value
    } = selectedConfig;
    const options = {
      mutation: REQUEST_SECURE_DATA,
      variables: {
        messageId: messageContext.message.messageId,
        options: [{
          name: label,
          valueType: value
        }]
      },
      functionName: "requestSecureData",
      notifyDetails: {
        errorNotification: "Failed to request secure data",
        successNotification: "Sensitive data requested successfully"
      },
      postSuccessFunction: callback
    };
    mutateData(options);
  };
  return {
    selectedConfig,
    setSelectedConfig,
    configSuggestions,
    createSecureDataRequest
  };
};